import storageSession from 'redux-persist/es/storage/session';

export default {
  key: 'root',
  storage: storageSession,
  blacklist: [],
};
